import { render, staticRenderFns } from "./DataTitle.vue?vue&type=template&id=27216ef9&scoped=true&"
import script from "./DataTitle.vue?vue&type=script&lang=js&"
export * from "./DataTitle.vue?vue&type=script&lang=js&"
import style0 from "./DataTitle.vue?vue&type=style&index=0&id=27216ef9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27216ef9",
  null
  
)

export default component.exports